/**
 * Types
 */

 export const Types = {
    SET_INSTALLMENT_VALUE: "installment/SET_INSTALLMENT_VALUE",
  }
  